import { LoginByTokenController as controller } from './loginByToken.controller';
import template from './loginByToken.html';
import '../../common/ui/componentHeader/componentHeader';

export const loginByTokenComponent = {
  name: 'loginByTokenComponent',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    returnTo: '<',
  },
};
